import { call, put, takeLatest } from "redux-saga/effects";
import { BannerAds, GetListResponse } from "@app/types";
import BannerService from "@app/services/http/banner.service";
import { setBannerAdsErrorMessage, storeBannerAds } from "./banner-ads.slice";

export const fetchBannerAdsAction = () => {
  return {
    type: "@bannerAds/fetchBannerAdsAction",
  };
};

function* fetchBannerAds(): Generator {
  try {
    const bannerAdsRes = (yield call(
      BannerService.getBannerAdsList
    )) as GetListResponse<BannerAds>;

    if (bannerAdsRes?.data?.items?.length) {
      yield put(
        storeBannerAds(
          bannerAdsRes.data.items.filter((item) => item.status && !!item.script)
        )
      );
    } else {
      yield put(storeBannerAds([]));
    }
  } catch (e: any) {
    yield put(setBannerAdsErrorMessage(e.message));
  }
}

function* bannerAdsSaga() {
  yield takeLatest(fetchBannerAdsAction().type, fetchBannerAds);
}

export default bannerAdsSaga;
